export const SECTION_NAVIGATION_SIDEBAR_MEDIA = '@media (min-width: 1360px)';
